import { IFRResource } from "app/resources/ifrresource";

export class UserChangePasswordResource extends IFRResource {

    email: string;

    oldPassword: string;

    newPassword: string;

}